export default {
  id: 1,
  pride: 49152,
  slug: "sanctuary-of-writers",
  category: "blog",
  status: "released",
  titleKey: {
    zh: "作家之屋",
    en: "Sanctuary Of Writers"
  },
  image: require('@/assets/images/teacat.webp'),
  descriptionKey: {
    zh: "博客。",
    en: "Blog."
  },
  date: { year: 2023, month: 11 },
  genres: ["博客", "个人网站"],
  themes: ["思想记录", "创作记录"],
  engine: "Web",
  platform: ["Web"],
  achievements: [
    { zh: "B站 1900 粉丝，缓慢增长中", en: "1,900 Bilibili followers, growing slowly" },
    { zh: "两个粉丝群：独立游戏群 80 人，VRChat群 11 人", en: "Two fan groups: Indie Game (80 members), VRChat (11 members)" }
  ],
  developerNotesKey: {
    zh: "主要阵地之一。小说的读者都是个位数，发布在微信公众号和个人博客。担心发到其他平台被吃版权，想干干净净的。B站目前1900粉丝，缓慢增长中，会重回两千的。",
    en: "One of the main bases. Novels have single-digit readers, published on WeChat Official Account and personal blog to avoid losing copyright to mainstream platforms. Bilibili currently has 1,900 followers, growing slowly, will return to 2,000."
  },
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "blog", url: "https://tobenot.top/", textKey: { zh: "访问博客", en: "Visit Blog" } }
  ]
};
